import { useCallback, useEffect, useState } from "react";
import supportApi from "support/api/supportApi";

// Keyset pagination: the server hands back an opaque next_cursor, the client
// never builds one.
export default function useConversations(active) {
  const [items, setItems] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const fetchPage = useCallback(async (nextCursor) => {
    setLoading(true);
    setError(null);
    const response = await supportApi.listConversations(
      nextCursor ? { limit: 20, cursor: nextCursor } : { limit: 20 }
    );
    setLoading(false);
    setLoaded(true);
    if (response.status !== 200 || !response.data) {
      setError(response.status);
      return;
    }
    const page = Array.isArray(response.data.data) ? response.data.data : [];
    setItems((current) => (nextCursor ? current.concat(page) : page));
    setCursor(response.data.next_cursor || null);
  }, []);

  useEffect(() => {
    if (active && !loaded && !loading) {
      fetchPage(null);
    }
  }, [active, loaded, loading, fetchPage]);

  return {
    items,
    loading,
    error,
    hasMore: !!cursor,
    loadMore: () => fetchPage(cursor),
    reload: () => fetchPage(null),
  };
}
